// extracted by mini-css-extract-plugin
module.exports = {"container":"OptionsButton_container__gAH8o","dot":"OptionsButton_dot__13KWM"};